import classNames from 'classnames'
import moment from 'moment'
import { useState } from 'react'
import { formatDecimalPlaces } from '../../../helpers/functions/format-decimal-places'
import { useGetDates } from '../../../hooks/date/use-get-dates'
import { useGetMyProfile } from '../../../hooks/queries/profile/use-get-my-profile'
import { useGetUsersHostsTasksSpecialsWeekends } from '../../../hooks/queries/users-tasks/users-hosts-tasks-specials-weekends/use-get-users-hosts-tasks-specials-weekends'
import { useGetUsersHostsTasksSpecials } from '../../../hooks/queries/users-tasks/users-hosts-tasks-specials/use-get-users-hosts-tasks-specials'
import type { UserHostTaskSpecial } from '../../../services/users-tasks/users-hosts-tasks-specials/types'
import { TaskLevelCard } from './task-level-card'

interface Props {
  taskSpecial: UserHostTaskSpecial
  currentWeekMonday: string
  nextSunday: string
}

function handleFormatDate(date: string) {
  return moment(date).format('DD/MM/YYYY')
}

function Tasks({ taskSpecial, currentWeekMonday, nextSunday }: Props) {
  const { user } = useGetMyProfile()

  console.log('Rendering Tasks for taskSpecial id:', taskSpecial.id)

  const { usersHostsTasksSpecialsWeekends } =
    useGetUsersHostsTasksSpecialsWeekends({
      userId: user?.id,
      dateInitial: currentWeekMonday,
      dateFinal: nextSunday,
      typeFilterDate: 'between',
      userHostTaskSpecialId: taskSpecial.id,
    })

  const third = usersHostsTasksSpecialsWeekends?.at(2)

  const isCompleted = usersHostsTasksSpecialsWeekends?.every((task) => {
    return task?.completed && !task?.received
  })

  // userHostTaskSpecialWeekendRescued
  // taskSpecial?.userHostTaskSpecialDefaultId
  function handleRescue() {
    if (isCompleted) {
      alert('completed')
    }

    if (!isCompleted) {
      alert(taskSpecial?.userHostTaskSpecialDefaultId)
    }
  }

  return (
    <>
      {third && (
        <div className="w-full rounded-2xl p-4 bg-gradient-to-b from-pink-500  to-blue-400 text-white mt-4">
          <div className="flex flex-col gap-2">
            <span className="text-sm">
              Ciclo de tarefas:
              <span className="font-semibold ml-1">
                {handleFormatDate(third?.dateInitial)} -{' '}
                {handleFormatDate(third?.dateFinal)}
              </span>
            </span>

            <span className="text-sm">
              Nível da tarefa:
              <span className="font-semibold ml-1">Lv.{third?.levelTask}</span>
            </span>

            <div className="flex items-center justify-between mt-3 bg-white/30 rounded-xl p-3">
              <span className="text-lg font-bold flex items-center gap-1">
                💎 {formatDecimalPlaces(third?.pointReward)}
              </span>

              <button
                disabled={!isCompleted}
                onClick={handleRescue}
                className={classNames(
                  'w-8 h-8 rounded-full  flex items-center justify-center',
                  {
                    'bg-yellow-400': isCompleted,
                    'bg-gray-400 grayscale-75': !isCompleted,
                  },
                )}
              >
                ✓
              </button>
            </div>
          </div>
        </div>
      )}

      {Boolean(usersHostsTasksSpecialsWeekends?.length) && (
        <div className="flex w-full flex-col mt-4 gap-10">
          <TaskLevelCard tasks={usersHostsTasksSpecialsWeekends || []} />
        </div>
      )}
    </>
  )
}

export function SpecialTask() {
  const [activeTab, setActiveTab] = useState<string>('current')

  const { user } = useGetMyProfile()
  const { formatDate } = useGetDates()

  let currentWeekMonday: string
  let nextSunday: string
  let lastWeekMonday: string
  let lastSunday: string

  const dayOfWeek = moment().get('day') + 1 // 0 (Domingo) a 6 (Sábado)

  console.log('Current day of the week:', dayOfWeek)

  if (dayOfWeek !== 0) {
    currentWeekMonday = moment()
      .startOf('week')
      .add(1, 'day')
      .format(formatDate)

    lastWeekMonday = moment()
      .startOf('week')
      .add(1, 'day')
      .subtract(1, 'week')
      .format(formatDate)

    nextSunday = moment()
      .utc()
      .startOf('week')
      .add(1, 'week')
      .format(formatDate)

    lastSunday = moment().startOf('week').format(formatDate)

    console.log({ lastWeekMonday, lastSunday })
    console.log({ currentWeekMonday, nextSunday })
  } else {
    lastWeekMonday = moment()
      .startOf('week')
      .add(1, 'day')
      .subtract(1, 'week')
      .format(formatDate)

    lastSunday = moment().startOf('week').format(formatDate)

    currentWeekMonday = moment()
      .startOf('week')
      .add(1, 'day')
      .format(formatDate)

    nextSunday = moment()
      .utc()
      .startOf('week')
      .add(1, 'week')
      .format(formatDate)

    console.log({ lastWeekMonday, lastSunday })
    console.log({ currentWeekMonday, nextSunday })
  }

  // console.log('Current Week Monday:', currentWeekMonday)
  // console.log('Next Sunday:', nextSunday)

  const { usersHostsTasksSpecials } = useGetUsersHostsTasksSpecials({
    userId: user?.id,
    dateInitial: currentWeekMonday,
    dateFinal: nextSunday,
    typeFilterDate: 'between',
  })

  const { usersHostsTasksSpecials: usersHostsTasksSpecialsLastWeek } =
    useGetUsersHostsTasksSpecials({
      userId: user?.id,
      dateInitial: lastWeekMonday,
      dateFinal: lastSunday,
      typeFilterDate: 'between',
    })

  // console.log(
  //   'usersHostsTasksSpecials for current week:',
  //   usersHostsTasksSpecials,
  // )
  // console.log(
  //   'usersHostsTasksSpecials for last week:',
  //   usersHostsTasksSpecialsLastWeek,
  // )

  return (
    <div className="flex flex-col items-center justify-between w-full py-2 px-4">
      <div className="flex flex-row gap-6 relative z-30 ">
        {Boolean(usersHostsTasksSpecialsLastWeek?.length) && (
          <button
            onClick={() => setActiveTab('previous')}
            className={classNames(
              'pb-1 font-bold transition-all text-white text-sm',
              activeTab === 'previous'
                ? 'border-b-1 border-white'
                : 'opacity-70',
            )}
          >
            Anterior
          </button>
        )}

        {Boolean(usersHostsTasksSpecials) && (
          <button
            onClick={() => setActiveTab('current')}
            className={classNames(
              'pb-1 font-bold transition-all text-white text-sm',
              activeTab === 'current'
                ? 'border-b-1 border-white'
                : 'opacity-70',
            )}
          >
            Atual
          </button>
        )}
      </div>

      {activeTab === 'previous' &&
        usersHostsTasksSpecialsLastWeek?.map((taskSpecial) => (
          <Tasks
            key={taskSpecial?.id}
            taskSpecial={taskSpecial}
            currentWeekMonday={lastWeekMonday}
            nextSunday={lastSunday}
          />
        ))}

      {activeTab === 'current' &&
        usersHostsTasksSpecials?.map((taskSpecial) => (
          <Tasks
            key={taskSpecial?.id}
            taskSpecial={taskSpecial}
            currentWeekMonday={currentWeekMonday}
            nextSunday={nextSunday}
          />
        ))}
    </div>
  )
}

export function SpecialTasks() {
  return <SpecialTask />
}
